/**
 * @generated SignedSource<<d39576d7bee5113bae9fc0273b49031f>>
 * @relayHash 585935353be655fa901655a87abfee97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b346b69a2ac553d8cbea80e17f800abbf81b473a35dd03bb3e2add77fbb033b2

import type { ConcreteRequest } from 'relay-runtime';
export type ContainerType = "BLOGPOST" | "DATABASE" | "PAGE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type ReactionsConfluenceSaveReactionMutation$variables = {
  cloudId: string;
  containerId: AGG$Long;
  containerType: ContainerType;
  contentId: AGG$Long;
  contentType: GraphQLReactionContentType;
  emojiId: string;
};
export type ReactionsConfluenceSaveReactionMutation$data = {
  readonly confluence_addReaction: {
    readonly ari: string | null;
    readonly containerAri: string | null;
    readonly emojiId: string | null;
  } | null;
};
export type ReactionsConfluenceSaveReactionMutation = {
  response: ReactionsConfluenceSaveReactionMutation$data;
  variables: ReactionsConfluenceSaveReactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emojiId"
},
v6 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          },
          {
            "kind": "Variable",
            "name": "containerType",
            "variableName": "containerType"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "contentType",
            "variableName": "contentType"
          },
          {
            "kind": "Variable",
            "name": "emojiId",
            "variableName": "emojiId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceReactionPayload",
    "kind": "LinkedField",
    "name": "confluence_addReaction",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "ari"
      },
      {
        "kind": "ScalarField",
        "name": "containerAri"
      },
      {
        "kind": "ScalarField",
        "name": "emojiId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReactionsConfluenceSaveReactionMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReactionsConfluenceSaveReactionMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "585935353be655fa901655a87abfee97",
    "id": "b346b69a2ac553d8cbea80e17f800abbf81b473a35dd03bb3e2add77fbb033b2",
    "metadata": {},
    "name": "ReactionsConfluenceSaveReactionMutation",
    "operationKind": "mutation",
    "text": "mutation ReactionsConfluenceSaveReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_addReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
  }
};
})();

(node as any).hash = "8801ac011dd1c9144f2e5afc0393b4f7";

export default node;
